import { render } from "./RhInfo.vue?vue&type=template&id=0c8c1608&scoped=true&ts=true"
import script from "./RhInfo.vue?vue&type=script&lang=ts"
export * from "./RhInfo.vue?vue&type=script&lang=ts"

import "./RhInfo.vue?vue&type=style&index=0&id=0c8c1608&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8c1608"]])

export default __exports__